import { FeedbackFormFields } from "../view/FeedBackForm.typedef";

export const defaultFeedbackFormState: FeedbackFormFields = {
	question: "",
	name: "",
	phone: "",
	email: "",
};
